module.exports = __webpack_public_path__ + "img/duration.a0982734.svg";